/**
 * Created by andrey on 23.09.2025
 */

connector.version = "1.0.27";